import AIOApis from "./../../components/aio/aio-apis";
import AIODate from "./../../components/aio/aio-date";
import { I_city, I_gridFilter, I_gridServerFilter, I_model, I_model_images, I_role, I_type, I_typesDic } from "./types";

export default class Apis extends AIOApis {
    base_url: string;
    typesDic:I_typesDic
    constructor(p: { base_url: string, token: string,typesDic:I_typesDic }) {
        super({
            id: 'freelancer',
            lang: 'fa',
            token: p.token,
            handleErrorMessage: (error) => {
                return error.response.data.messages[0].message
            },
        })
        this.base_url = p.base_url
        this.typesDic = p.typesDic
    }

    getGridServerFilter = (gridFilter: I_gridFilter): I_gridServerFilter => {
        const a = {
            "name": "string",
            "personelCode": "string",
            "nationalCode": "string",
            "mobile": "string",
            "email": "string",
            "isActive": true,
            "username": "string",
            "hasInsurance":undefined,
            "selectHub": {
                "id": 0,
                "text": "string"
            },
            "hublist": [
                {
                    "id": 0,
                    "value": "string",
                    "label": "string",
                    "parent": 0
                }
            ],
            "employeeType": "0"
        }
        const res: I_gridServerFilter = { selectHub: { id: 1 }, isActive: true }
        let types: I_type[] = Object.keys(this.typesDic).map((o) => this.typesDic[o].value)
        if (typeof gridFilter.type === 'number') { types = [gridFilter.type] }
        res.types = types
        if (gridFilter.name) { res.name = gridFilter.name }
        if (gridFilter.isActive !== undefined) { res.isActive = gridFilter.isActive }
        if (gridFilter.advanced?.mobile) { res.mobile = gridFilter.advanced.mobile }
        if (gridFilter.advanced?.nationalCode) { res.nationalCode = gridFilter.advanced.nationalCode }
        if (gridFilter.advanced?.hasInsurance !== undefined) { res.hasInsurance = gridFilter.advanced.hasInsurance }
        return res
    }
    convertDate = (dateString: string): { year: number, month: number, day: number } => {
        const [year, month, day] = new AIODate().toArray(dateString)
        return { year, month, day }
    }
    toIsoDate = (birthDate: string) => {
        const DATE = new AIODate();
        const dd = DATE.toGregorian(birthDate)
        const [y, m, d] = DATE.toArray(dd)
        return new Date(y, m - 1, d).toISOString();
    }
    documentsToImages = (documents: I_model["documents"]): I_model_images => {
        const images: I_model_images = {}
        try {
            const imageDic: {[key in keyof I_model["images"]]:number} = {
                'nationalIdFrontDocId': 1,
                'nationalIdBackDocId': 2,
                'drivingLicenceFrondDocId': 3,
                'drivingLicenceBackDocId': 4,
                'vehicleIdFrontDocId': 5,
                'vehicleIdBackDocId': 6,
                'vehicleInsurancePaperDocId': 7,
                'bankPaperDocId': 8,
                'contractPaperDocId': 9
            }
            for (let imageKey in imageDic) {
                const obj = documents.find((o) => o.type.id === imageDic[imageKey])
                if (!obj) { continue }
                const imageId = obj.id
                const field: any = imageKey
                if (typeof imageId === 'string') {
                    const url = `${this.base_url}/storage-api/indexed-objects/${imageId}/as-file`
                    images[field] = { url, imageId, newUpload: false }
                }
            }
        }
        catch (err) {
            console.log(err.message)
        }
        return images
    }
    imagesToDocuments = async (imagesData: I_model_images):Promise<I_model["documents"]> => {
        const imageDic: { [key in keyof I_model_images]: number } = {
            'nationalIdFrontDocId': 1,
            'nationalIdBackDocId': 2,
            'drivingLicenceFrondDocId': 3,
            'drivingLicenceBackDocId': 4,
            'vehicleIdFrontDocId': 5,
            'vehicleIdBackDocId': 6,
            'vehicleInsurancePaperDocId': 7,
            'bankPaperDocId': 8,
            'contractPaperDocId': 9
        }
        const documents: I_model["documents"] = []
        for (let prop in imageDic) {
            let { imageId, url, newUpload } = imagesData[prop] || {}
            if (url) {
                const type = imageDic[prop];
                if (newUpload) {
                    if (url.indexOf('http') === 0) {
                        alert('error in images')
                        //danger
                    }
                    const res = await this.upload(url);
                    if (res) { imageId = res }
                }
                documents.push({ id: imageId, type })
            }
        }
        return documents
    }
    enums = async () => {
        const url = `${this.base_url}/core-api/common/common-objects?includeProvinces=true&includeCities=true&includeHubs=true&includeSexType=true&includeVehicleTypes=true&includeEmployeeTypes=true&includeVehicleVendor=true&includeVehicleMakes=true`
        const { response, success } = await this.request<any>({
            name: 'enums',
            method: 'get',
            description: 'دریافت اطلاعات اولیه',
            url,
            //cache: { name: 'enums', expiredIn: new Date().getTime() + 100000000000 }
        })
        if (success) {
            return response.data.response
        }
        else { return false }
    }
    grid = async (gridFilter: I_gridFilter) => {
        const body = this.getGridServerFilter(gridFilter)
        const { response, success } = await this.request<{ data: { payload: { content: I_model[], totalElements: number } } }>({
            name: 'grid',
            method: 'post',
            description: 'دریافت اطلاعات جدول پرسنل', loading: true,
            url: `${this.base_url}/resource-api/employee/filter?pageNumber=${gridFilter.pageNumber}&pageSize=${gridFilter.pageSize}`,
            body
        })
        if (success) {
            return {
                rows: response.data.payload.content,
                length: response.data.payload.totalElements
            }
        }
        return false
    }
    add = async (addModel: I_model) => {
        const { response, success } = await this.request<{ data: { payload: I_model } }>({
            name: 'add', method: 'post',
            description: 'افزودن راننده', loading: true,
            url: `${this.base_url}/resource-api/employee`,
            body: addModel
        })
        if (success) {
            const model = response.data.payload
            return { ...model, images: this.documentsToImages(model.documents || []) }
        }
        return false
    }
    edit = async (editModel: I_model) => {
        if (editModel.images) {editModel.documents = await this.imagesToDocuments(editModel.images)}
        const { response, success } = await this.request<any>({
            name: 'edit',
            method: 'put',
            description: 'ویرایش راننده', loading: true,
            url: `${this.base_url}/resource-api/employee`,
            body: { ...editModel, id:editModel.id }
        })
        if (success) { return true }
        return false
    }
    remove = async (id: number) => {
        const { success } = await this.request<any>({
            name: 'remove',
            method: 'delete',
            description: 'حذف راننده', loading: true,
            url: `${this.base_url}/resource-api/employee/${id}`,
        })
        if (success) { return true }
        return false
    }
    initialEdit = async (id: number) => {
        const { response, success } = await this.request<any>({
            name: 'initialEdit',
            method: 'get',
            description: 'دریافت اطلاعات اولیه راننده برای ویرایش',
            loading: true,
            url: `${this.base_url}/resource-api/employee/${id}`
        })
        if (success) {
            const model: I_model = response.data.payload
            return { ...model, images: this.documentsToImages(model.documents || []) }
        }
        return false
    }
    cities = async () => {
        const { response, success } = await this.request<{
            data: {
                payload: I_city[]
            }
        }>({
            name: 'cities',
            method: 'get',
            url: `${this.base_url}/core-api/countryDevision/findbyCity?filter=`,
            description: 'دریافت لیست شهر ها'
        })
        if (success) {
            return response.data.payload
        }
        return false
    }
    fileToBase64 = (file: any) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.readAsDataURL(file); // یا readAsBinaryString هم هست، ولی این بهتره
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }
    upload = async (file: any, id?: string) => {
        let fd = new FormData();
        fd.append('file', base64ToFile(file))
        const { success, response } = await this.request<{ data: { response: { id: string } } }>({
            name: 'upload',
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            method: 'post',
            description: 'بارگزاری تصویر', loading: true,
            url: `${this.base_url}/storage-api/indexed-objects/FREELANCER/as-file`,
            body: fd
        })
        return success ? response.data.response.id : false
    }
    getImageFile = async (id: string) => {
        const { success, response } = await this.request<{ data: any }>({
            name: 'getImageUrl',
            method: 'get',
            description: 'دریافت آدرس تصویر', loading: true,
            url: `${this.base_url}/storage-api/indexed-objects/${id}/as-file`,
        })
        if (success) { return response.data }
        else { return false }
    }
    
    getAllRoles = async () => {
        const { success, response } = await this.request<{ data: { payload: { content: I_role[] } } }>({
            name: 'getAllRoles',
            method: 'get',
            description: 'دریافت لیست نفش ها', loading: true,
            url: `${this.base_url}/resource-api/role/select?filter=`,
        })
        if (success) {
            return response.data.payload.content
        }
        else {
            return false
        }
    }
    getRoleIds = async (id: number) => {
        const { success, response } = await this.request<{
            data: {
                response: {
                    roles: { id: number, text: string }[],
                    hubs: { id: number, text: string }[],
                    selectEmployee: { id: number, text: string }[]
                }[]
            }
        }>({
            name: 'getRoles',
            method: 'post',
            description: 'دریافت نقش های پرسنل', loading: true,
            url: `${this.base_url}/resource-api/role/v1/s0/getEmployeeRoles`,
            body: [id]
        })
        if (success) {
            try {
                return response.data.response[0].roles.map((o) => o.id)
            }
            catch (err) {
                alert(err.message)
                return false
            }
        }
        else {
            return false
        }
    }
    getHubIds = async (id: number) => {
        const { success, response } = await this.request<{
            data: {
                response: {
                    roles: { id: number, text: string }[],
                    hubs: { id: number, text: string }[],
                    selectmployee: { id: number, text: string }[]
                }[]
            }
        }>({
            name: 'getRoles',
            method: 'post',
            description: 'دریافت هاب های پرسنل', loading: true,
            url: `${this.base_url}/resource-api/role/v1/s0/getEmployeeRoles`,
            body: [id]
        })
        if (success) {
            try {
                return response.data.response[0].hubs
            }
            catch (err) {
                alert(err.message)
                return false
            }
        }
        else {
            return false
        }
    }
    changeRoles = async (employeeId: number, roleIds: number[]) => {
        const { success, response } = await this.request<any>({
            name: 'getRoles',
            method: 'post',
            description: 'ذخیره نقش های پرسنل', loading: true,
            url: `${this.base_url}/resource-api/employee/role2user`,
            body: {
                selectEmployee: { id: employeeId },
                selectRoles: roleIds.map((id) => ({ id }))
            }
        })
        if (success) {
            return true
        }
        else {
            return false
        }
    }
    changeHubs = async (employeeId: number, hubIds: number[]) => {
        const { success, response } = await this.request<any>({
            name: 'getRoles',
            method: 'post',
            description: 'ذخیره هاب های پرسنل', loading: true,
            url: `${this.base_url}/resource-api/employee/v1/hubpermission`,
            body: {
                selectemployee: { id: employeeId },
                hubList: hubIds,
                selecthublist: []
            }
        })
        if (success) {
            return true
        }
        else {
            return false
        }
    }
}

function base64ToFile(base64: any, fileName = 'upload.bin') {
    const arr = base64.split(',');
    const mime = arr[0]?.match(/:(.*?);/)?.[1] || 'application/octet-stream';
    const bstr = atob(arr[1] || arr[0]); // اگه header نداشت، کل base64 رو بگیر
    const n = bstr.length;
    const u8arr = new Uint8Array(n);
    for (let i = 0; i < n; i++) {
        u8arr[i] = bstr.charCodeAt(i);
    }
    return new File([u8arr], fileName, { type: mime });
}